/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  SuccessContainer,
  SuccessHeading,
  SuccessHeadingText,
  SuccessHeadingBigText,
  SuccessPaymentSummary,
  DeleteButton,
  LineDiv,
  CopyLink,
  CopyInput,
  CopyLinkButton,
  Copy,
  Share,
  PaymentSection,
  ProductBox,
  ProductBoxOut,
  PaymentBoxOut,
} from "./success.styled";
import styled from "styled-components";
import { GoArrowLeft } from "react-icons/go";
import { GoCopy } from "react-icons/go";
import { IoMdShare } from "react-icons/io";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import Preview from "../Preview";
import Product from "../Product";
import Details from "../Details/index";
import DeleteModal from "../Trash";
import QrCode from "../QrCode/qrcode";
import ShareModal from "../Share";
import PreviewOfPayment from "../PreviewOfPayment/PreviewOfPayment.component";
import CharityPreviewOfPayment from "../../pages/CharityDonation/CharityPreview";
import AdhocPreviewOfPayment from "../../pages/Adhoc/AdhocPreviewOfPayment";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { GET_PAYMENT_LINK } from "../../graphql/queries/paymentlink";
import { environment } from "../../env";
import { getData } from "../../utils/localStorage";
import { useDispatch, useSelector } from "react-redux";
import { removePaymentLink } from "../../store/products/createpaymentslice";
import DetailsCharity from "../Details/DetailsCharity";
import { ToastContainer } from "react-bootstrap";
import { generatePaymentLinkCheckout } from "../../utils/general";
import { CreateGoback } from "../../pages/CreatePaymentLink/CreatePaymentLink.styles";

const Tooltip = styled.div<{ visible: boolean }>`
  position: absolute;
  width: 372px;
  height: 100px;
  top: 100px;
  right: 10px;
  transform: translateX(-50%);
  background-color: #def1de;
  color: #388233;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    left: 55%;
    width: 60%;
    height: auto;
    top: 50%;
    padding: 1rem;
  }
`;

const Toolp = styled.div`
  font-family: "GT Walsheim Pro";
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #388233;
  @media screen and (min-width: 0px) and (max-width: 766px) {
  }
`;

const Toolspan = styled.div`
  font-family: "GT Walsheim Pro";
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #388233;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 0.8rem;
  }
`;

const ToolContentDiv = styled.div`
  padding-left: 20px;
  margin-top: 20px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin: 0;
    padding: 0;
  }
`;
const Notification = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: green;
  color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
`;

interface DataProps {
  // storageData?: any;
}

const type = getData("type");

const successcharity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { loading, error, data } = useQuery(GET_PAYMENT_LINK, {
    variables: { ...environment.paymentLinkService, paymentLinkId: id },
  });
  const dataType = data?.paymentLink.type;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
  const [isCopyTooltipVisible, setIsCopyTooltipVisible] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  const [storageData, setStorageData] = useState([]);
  const linkToCopy = generatePaymentLinkCheckout(data?.paymentLink?.shortcode);

  const handleDeleteButtonClick = () => {
    setIsModalVisible(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(linkToCopy);

      console.log("Deleting payment link...");
      setIsNotificationVisible(true);

      setTimeout(() => {
        handleCloseModal();
        setIsNotificationVisible(false);
        console.log("Payment link deleted successfully!");
      }, 1000);
    } catch (error) {
      console.error("Error deleting payment link:", error);
    }
  };

  const openShareModal = () => {
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const openQrCodeModal = () => {
    setIsQrCodeModalOpen(true);
  };

  const handleCopyButtonClick = () => {
    navigator.clipboard.writeText(linkToCopy);
    setIsCopyTooltipVisible(true);
    setTimeout(() => {
      setIsCopyTooltipVisible(false);
    }, 2000);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const closeModal = () => {
    setIsQrCodeModalOpen(false);
  };

  const NavigateToAddProduct = () => {
    navigate("/dashboard/add-product");
  };

  useEffect(() => {
    return () => {
      dispatch(removePaymentLink());
    };
  }, []);

  return (
    <>
      <SuccessContainer>
        <SuccessHeading>
          <SuccessHeadingBigText>
            <SuccessHeadingText>
              <img
                src="/assets/svg/goBack.svg"
                alt=""
                onClick={NavigateToAddProduct}
              />
              <CreateGoback>Go back</CreateGoback>
            </SuccessHeadingText>
            <h1>Payment Link Details</h1>
          </SuccessHeadingBigText>
          <DeleteButton onClick={handleDeleteButtonClick}>
            Delete Payment Link
          </DeleteButton>
        </SuccessHeading>
        <DeleteModal
          isVisible={isModalVisible}
          onDelete={handleDelete}
          onClose={handleCloseModal}
        />
        {isNotificationVisible && (
          <Notification>Payment link deleted successfully!</Notification>
        )}
        <SuccessPaymentSummary>
          <h2>Payment Link Summary</h2>
          <div>
            <LineDiv />
          </div>
          <p>Link</p>
          <div>
            <Tooltip visible={isCopyTooltipVisible}>
              <ToolContentDiv>
                <Toolp>Copied!</Toolp>
                <Toolspan>
                  Your payment link has been copied to the clipboard
                </Toolspan>
              </ToolContentDiv>
            </Tooltip>
            <CopyLink>
              <CopyInput type="text" value={linkToCopy} />

              <CopyLinkButton>
                <Copy onClick={handleCopyButtonClick}>
                  <GoCopy />
                  Copy Link
                </Copy>
                <Share onClick={openShareModal}>
                  <IoMdShare />
                  Share Link
                </Share>
                {isShareModalOpen && (
                  <ShareModal
                    isOpen={isShareModalOpen}
                    onClose={closeShareModal}
                    linkToCopy={linkToCopy}
                  />
                )}
                <Share onClick={openQrCodeModal}>
                  <MdOutlineQrCodeScanner />
                  QR Code
                </Share>
                {isQrCodeModalOpen && <QrCode onCancel={closeModal} />}
              </CopyLinkButton>
            </CopyLink>
          </div>
        </SuccessPaymentSummary>
        <PaymentSection>
          <ProductBoxOut>
            <p>Product</p>
            <ProductBox>
              {storageData?.map((products, index) => (
                <div key={index} style={{ width: "100%" }}>
                  <Product storageData={products} />
                </div>
              ))}
            </ProductBox>
            <DetailsCharity />
          </ProductBoxOut>
          <PaymentBoxOut>
            <CharityPreviewOfPayment />
          </PaymentBoxOut>
        </PaymentSection>
      </SuccessContainer>
    </>
  );
};

export default successcharity;
